export default "__VITE_ASSET__JLt1i$eE__"